<script setup lang="ts">
    import { Employee } from '@/types';
    import ContinueButton from '@/components/ContinueButton.vue';

    const props = defineProps<{
        employee: Employee;
    }>();

    const exportEmployeeChanges = () => {
        document.location.href = route('v2.salary.employee.changes.export', {
            id: props.employee.id,
        });
    };
</script>

<template>
    <ContinueButton @click="exportEmployeeChanges">
        {{ $t('forms.export') }}
    </ContinueButton>
</template>
